import { ColumnConfig } from '@dal/shared-ui';

export const ACTIVITY_QUEUE_COLUMNS: ColumnConfig[] = [
  { key: 'type', header: 'Type', type: 'text' },
  { key: 'thumbnails', header: 'Thumbnails', type: 'custom' },
  { key: 'status', header: 'Status', type: 'status' },
  { key: 'user', header: 'User', type: 'text' },
  { key: 'start time', header: 'Start Time', type: 'date', width: '130px' },
  { key: 'end time', header: 'End Time', type: 'date', width: '130px' },
  { key: 'actions', header: 'Actions', type: 'actions' },
];
